export { Indicator } from "@mantine/core";
